import _ from 'underscore';
import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { ChoiceGroup } from '@bingads-webui-react/fabric-control';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { CustomDropdown } from '../custom-dropdown-component';
import { getAssetTypeFilterStyle } from './style';

const AssetTypeFilterInternal = ({
  defaultAssetType,
  assetTypeFilterOptions,
  dropdownWidth,
  onChange,
  onDismiss,
  focused,
  i18n,
  classes,
}) => {
  //
  const [assetTypeFilter, setAssetType] = useState(defaultAssetType);

  // choice group handling
  const selectedChoice = useMemo(
    () => _.find(assetTypeFilterOptions, r => r.key === assetTypeFilter),
    [assetTypeFilter, assetTypeFilterOptions]
  );

  const onAssetTypeChange = useCallback((evt, option) => {
    if (option && option.key) {
      setAssetType(option.key);
    }
  }, []);

  // the string shown on dropdown title
  const dropdownTitle = selectedChoice ? selectedChoice.title : null;

  // when the X button on dropdown title is clicked
  const onDropdownClear = useCallback((isDropdownOpen) => {
    setAssetType(null);
    if (!isDropdownOpen && onChange && defaultAssetType !== null) {
      onChange(null);
    }
  }, [defaultAssetType, onChange]);

  // when dropdown list is dismissed
  const onDropdownDismiss = useCallback(() => {
    if (onChange && defaultAssetType !== assetTypeFilter) {
      onChange(assetTypeFilter, dropdownTitle);
    }
    if (onDismiss) {
      onDismiss(assetTypeFilter, dropdownTitle);
    }
  }, [onChange, defaultAssetType, assetTypeFilter, onDismiss, dropdownTitle]);

  return (
    <CustomDropdown
      title={dropdownTitle}
      placeholder={i18n.getString(_TL_('Asset type'))}
      dropdownWidth={dropdownWidth}
      onClear={onDropdownClear}
      onDismiss={onDropdownDismiss}
      focused={focused}
    >
      <div className={classes.assetTypeFilterDowndown}>
        <div className="dropdown-title">{i18n.getString(_TL_('Asset type'))}</div>
        <ChoiceGroup
          className="dropdown-asset-type-choices"
          selectedKey={selectedChoice ? selectedChoice.key : ''}
          options={assetTypeFilterOptions}
          onChange={onAssetTypeChange}
        />
      </div>
    </CustomDropdown>
  );
};

AssetTypeFilterInternal.propTypes = {
  defaultAssetType: PropTypes.string,
  assetTypeFilterOptions: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    text: PropTypes.string,
  })).isRequired,
  onChange: PropTypes.func,
  onDismiss: PropTypes.func,
  focused: PropTypes.bool,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  dropdownWidth: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  classes: PropTypes.shape({
    assetTypeFilterDowndown: PropTypes.string,
  }).isRequired,
};

AssetTypeFilterInternal.defaultProps = {
  defaultAssetType: null,
  onChange: undefined,
  onDismiss: undefined,
  focused: false,
  dropdownWidth: 0,
};

export const AssetTypeFilter
  = withDefaultStyles(AssetTypeFilterInternal, getAssetTypeFilterStyle);
